$(function () {
    $(window).scroll(function () {
        stickyBlock();
    });

    $("document").ready(function () {
        // Formulaire "Création de compte"
        if ($("#factu-address").length) {
            initForm(lang_phone);
        }

        $('body').on('click', '#btn-disponibility', function (e) {
            if ( $('#reservation-type').val() != '' && $('#quantity-A').val() != 0) {
                e.preventDefault();
                disponibility()
            }else{
                $("html, body").animate({scrollTop: $('#js-reservation').offset().top}, 100);
                $('.alert.alert-danger.data').show();
            }
        });
    });


    function disponibility(current_month = '',current_year = '') {
        displayLoader(false);
        $.ajax({
            url: '/' + url_lang + '/ajax/reservation-disponibility',
            type: 'POST',
            data: {
                'month': current_month,
                'year': current_year,
                'type': $('#type').val(),
                'service': $('#service').val(),
                'type_reservation': $('#reservation-type').val(),
                'qty_adult': $('#quantity-A').val(),
                'qty_child': $('#quantity-E').val(),
                'qty_baby': $('#quantity-B').val()
            },
            dataType: 'json',
            success: function (data) {
                var promo_dates = data.promo;
                var disponible_dates = data.disponible;

                $('#date-picker-disponibilite').datepicker({
                    language: url_lang,
                    minDate: new Date(),
                    position: 'bottom right',
                    autoClose: true,
                    onSelect(date){
                        $('#date-picker').val(date);
                        $('.update-reservation').show();
                    },
                    onChangeMonth(month, year) {
                        disponibility(month,year);
                    },
                    onRenderCell(date) {
                        var d = date;
                        var curr_date = date.getDate();
                        var curr_month = d.getMonth() + 1; //Months are zero based
                        var curr_year = d.getFullYear();
                        var formattedDate = curr_date.toString().padStart(2, '0') + "/" + curr_month.toString().padStart(2, '0') + "/" + curr_year

                        if ($.inArray(formattedDate, promo_dates) != -1) {
                            return {
                                classes: 'promo'
                            };
                        }
                        if ($.inArray(formattedDate, disponible_dates) != -1) {
                            return {
                                classes: 'disponible'
                            };
                        }
                        return{
                            disabled: true
                        };
                    },

                });
                $('#legend-disponibilite').show();
                $('#date-picker-disponibilite').show();
                displayLoader(true);
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
            }
        });
    }

    function initForm(country) {
        var countryData = window.intlTelInputGlobals.getCountryData(),
            input = document.querySelector("#fact-phone");

        var iti = window.intlTelInput(input, {
            allowDropdown: true,
            separateDialCode: true,
            initialCountry: country,
            hiddenInput: "full",
            formatOnDisplay: false,
            utilsScript: "/assets/front/js/intlTelInputUtils.js"
        });
    }

    $('body').on('click', '.results-item-element-heading', function (e) {
        $(this).closest('.results-item-element').toggleClass('show');
        return false;
    });

    $('body').on('click', '.quantity-button', function (e) {
        var $button = $(this);
        var oldValue = $button.parent().find("input").val();
        var newVal;
        var reservation_type = $('#reservation-type').val();

        if ($button.text().trim() == "+") {
            if ($button.data('type') != undefined &&
                ($button.data('type') == 'product' || $button.data('type') == 'option') &&
                ((oldValue < 16 && (reservation_type == '24' || reservation_type == '25'))
                    || (oldValue < 12 && reservation_type != '24' && reservation_type != '25'))) {
                newVal = parseFloat(oldValue) + 1;
            } else {
                newVal = oldValue;
            }
        } else {
            if (oldValue > 0) {
                newVal = parseFloat(oldValue) - 1;
            } else {
                newVal = 0;
            }
        }

        $button.parent().find("input").val(newVal);


        if ($button.data('type') != undefined && $button.data('type') == 'option') {
            // $option_firstname = $('#option-firstname-' + $button.data('option-id')).val();

            displayLoader(false);
            //@todo - Vérification nb option/nb résa + si pas choix de résa
            $.ajax({
                url: '/' + url_lang + '/ajax/reservation-add-option',
                type: 'POST',
                data: {
                    'noArticle': $button.data('noarticle'),
                    'price': $button.data('price'),
                    'qty': newVal,
                    'option-id': $button.data('option-id'),
                    // 'option-firstname': $option_firstname,
                },
                dataType: 'json',
                success: function (data) {
                    if (data.views) {
                        renderAjaxResponse(data);
                        if (data.display_scin) {
                            $('#option-scintillant').show();
                            if (window.matchMedia("(max-width: 884px)").matches) {
                                $('.reservation-item.js-option-list').css('margin-bottom', '160px');
                            }
                        }
                        stickyBlock();
                    }
                    displayLoader(true);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
                }
            });
        }
    });

    var $resagrid = $('.reservation-item .grid').masonry({
        itemSelector: '.grid-item',
        gutter: 10,
        columnWidth: '.grid-sizer',
        isFitWidth: true
    });

    $resagrid.imagesLoaded().progress(function () {
        $resagrid.masonry('layout');
    });


    /* pour afficher la liste des cross products apres avoir selectionne un produit en etape 1 */
    var masonryUpdate = function () {
        setTimeout(function () {
            $('#display-option').find('.grid').masonry(
                {
                    itemSelector: '.grid-item',
                    gutter: 10,
                    columnWidth: '.grid-sizer',
                    isFitWidth: true
                }
            );
        }, 0);
    }

    $('#fact').popup({
        closebutton: true,
        closebuttonmarkup: '<a href="#"><div class="icon icon-cross"><span class="sr-only">X</span></div></a>'
    });
    $('#delivery').popup({
        closebutton: true,
        closebuttonmarkup: '<a href="#"><div class="icon icon-cross"><span class="sr-only">X</span></div></a>'
    });

    $('#reservation-type').change(function () {
        //On vide les blocs de résultats

        $.ajax({
            url: '/' + url_lang + '/ajax/reservation-delete',
            type: 'POST',
            dataType: 'json',
            success: function (data) {
                if (data.views) {
                    renderAjaxResponse(data);
                    stickyBlock();
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
            }
        });


        $('.reservation-sub-type').hide();
        $('#reservation-type-' + $(this).val()).show();
        $('.form-group-resa.hide-bon-cadeau').css('display', 'flex');
        $('.form-group-resa.hide-diner-dejeuner').css('display', 'flex');
        $('.quantity-label.hide-diner-dejeuner').css('display', 'flex');

        if ($(this).val() == 'bon_cadeau') {
            $('#reservation-item-date').hide();
            $('.promo-item.hide-bon-cadeau').hide();
            $('.form-group-resa.hide-bon-cadeau').hide();
            $('.quantity-label.hide-bon-cadeau').hide();
            $('.reservation-left-title.title_bons_cadeaux').css('display', 'flex');
            $('.reservation-left-title.title').hide();
            $('.update-reservation').show();
            $('#reservation-disponibility').hide();
            $('#legend-disponibilite').hide();
        }else if($(this).val() == 'evenementiel') {
            $('.reservation-left-title.title_bons_cadeaux').hide()
            $('.reservation-left-title.title').css('display', 'block');
            $('.promo-item.hide-bon-cadeau').show();
            $('#reservation-item-date').show();
            $('.quantity-label.hide-bon-cadeau').css('display', 'flex');
            $('.quantity-label.hide-diner-dejeuner').hide();
            $('.update-reservation').show();
            $('#reservation-disponibility').hide();
            $('#legend-disponibilite').hide();
            if ($(this).val() != '23') {
                $('.form-group-resa.hide-diner-dejeuner').hide();

            }

        }else{
            $('#reservation-disponibility').show();
            $('.reservation-left-title.title_bons_cadeaux').hide()
            $('.reservation-left-title.title').css('display', 'block');
            $('.promo-item.hide-bon-cadeau').show();
            $('#reservation-item-date').show();
            $('.quantity-label.hide-bon-cadeau').css('display', 'flex');
            if ($(this).val() != '23') {
                $('.form-group-resa.hide-diner-dejeuner').hide();

            }
            $('.quantity-label.hide-diner-dejeuner').hide();
            $('.update-reservation').hide();
            if($('#date-picker-disponibilite').css('display') == 'block') {
                $('#date-picker-disponibilite').hide();
                $('#legend-disponibilite').hide();
            }
        }

    })


    $('body').on('click', '.update-reservation', function (e) {
        e.preventDefault();
        $('.reservation-ticket').remove();
        if ($('#reservation-type').val() != '' && $('#quantity-A').val() != 0) {
            $this = $(this);
            displayLoader(false);

            $type_bon_cadeau = $type_evenementiel = '';
            if ($('#reservation-type').val() == 'bon_cadeau') {
                $type_bon_cadeau = $('#reservation-type-bon_cadeau').val();
            }

            if ($('#reservation-type').val() == 'evenementiel') {
                $type_evenementiel = $('#reservation-type-evenementiel').val();

                $.ajax({
                    url: '/' + url_lang + '/ajax/reservation-check-date',
                    type: 'POST',
                    data: {
                        'date': $('#date-picker').val(),
                        'type_evenementiel': $type_evenementiel,
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.error) {
                            $("html, body").animate({scrollTop: $('#js-reservation').offset().top}, 100);
                            $('.alert.alert-danger.date').show();
                            $('.alert.alert-danger.data').hide();
                            displayLoader(true);
                        } else {
                            searchReservation($type_bon_cadeau, $type_evenementiel);
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
                    }
                });
            } else {
                searchReservation($type_bon_cadeau, $type_evenementiel);
            }


        } else {

            $("html, body").animate({scrollTop: $('#js-reservation').offset().top}, 100);
            $('.alert.alert-danger.data').show();
        }
    });

    // Vérification si le tunnel de commande : étape 2 récapitulatif
    // On vérifie que l'utilisateur a accepté les CGV
    $('body').on('click', '#recap-submit-2', function (e) {
        if ($('#form-conditions').prop('checked') === false) {
            var offset = $('.reservation-left').offset().top;
            $('html').animate({scrollTop: offset - 5}, 100);
            if ($('.reservation-ticket .alert').length !== 0) {
                if ($('#errorTermsConditions').length === 0) {
                    $('.reservation-ticket .alert ul').append('<li id="errorTermsConditions">Veuillez accepter les conditions générales de vente.</li>');
                } else {
                    $('.reservation-ticket .alert ul').fadeOut(200);
                    $('.reservation-ticket .alert ul').fadeIn(200);
                }
            } else {
                if ($('#noAddresses').length >= 1) {
                    $('.reservation-ticket-recap-title').after('<div class="alert alert-danger" id="errorTermsConditions"><ul><li>Veuillez accepter les conditions générales de vente.</li><li>L\'adresse de facturation est obligatoire.</li></ul></div>');
                } else {
                    $('.reservation-ticket-recap-title').after('<div class="alert alert-danger" id="errorTermsConditions"><ul><li>Veuillez accepter les conditions générales de vente.</li></ul></div>');
                }
            }
        }
    });

    $('body').on('change', '#reservation-type-evenementiel', function (e) {
        $this = $(this);
        displayLoader(false);
        if ($this.val() != '' && $this.val() != 0) {
            $.ajax({
                url: '/' + url_lang + '/ajax/reservation-date-evenement',
                type: 'POST',
                data: {
                    'noCroisiere': $this.val(),
                },
                dataType: 'json',
                success: function (data) {
                    if (data.date) {
                        if(url_lang=='en') {
                            $('#date-picker').val(data.date_month.toString().padStart(2, '0') + "/" + data.date_day.toString().padStart(2, '0') + "/" + data.date_year);
                        }else{
                            $('#date-picker').val(data.date_day.toString().padStart(2, '0') + "/" + data.date_month.toString().padStart(2, '0') + "/" + data.date_year);
                        }

                    } else {
                        $('#date-picker').val('');

                    }
                    displayLoader(true);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
                }
            });
        } else {
            $('#date-picker').val('');

            displayLoader(true);
        }
    });
    $('body').on('click', '.select-cruise', function (e) {
        e.preventDefault();
        $checked = false;
        $('.results-item-element-radio .form-check-container-radio').children('input').each(function () {

            if ($(this).prop('checked')) {
                $checked = true;
                $checked_value = $(this).val();
            }
        });

        if ($checked) {
            displayLoader(false);
            choiceOptions();
        } else {
            //@todo - Message d'erreur
        }

    });
    $('body').on('click', '.add-lastname', function (e) {
        e.preventDefault();
        $checked = false;
        $button = $(this);
        $option_firstname = $('#option-firstname-' + $button.data('option-id'));

        if ($option_firstname.val() != '') {
            displayLoader(false);
            $.ajax({
                url: '/' + url_lang + '/ajax/reservation-add-option-firstname',
                type: 'POST',
                data: {
                    'noArticle': $button.data('noarticle'),
                    'option-id': $button.data('option-id'),
                    'option-firstname': $option_firstname.val(),
                },
                dataType: 'json',
                success: function (data) {
                    if (data.success) {
                        $('.success-firstname').show();
                        displayLoader(true);
                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
                }
            });
        } else {
            //@todo - Message d'erreur
        }

    });

    var searchReservation = function () {
        $.ajax({
            url: '/' + url_lang + '/ajax/reservation-search',
            type: 'POST',
            data: {
                'date': $('#date-picker').val(),
                'type': $('#type').val(),
                'service': $('#service').val(),
                // 'promo_code': $('#promo-code').val(),
                'type_reservation': $('#reservation-type').val(),
                'type_bon_cadeau': $type_bon_cadeau,
                'type_evenementiel': $type_evenementiel,
                'qty_adult': $('#quantity-A').val(),
                'qty_child': $('#quantity-E').val(),
                'qty_baby': $('#quantity-B').val()
            },
            dataType: 'json',
            success: function (data) {
                if (data.views) {
                    $('.alert.alert-danger.data').hide();
                    $('.alert.alert-danger.date').hide();
                    $('.code-response').removeClass('parsley-error-text').html('');

                    $('.update-reservation').html(data.update_reservation_label)
                    renderAjaxResponse(data);
                    stickyBlock();
                    displayLoader(true);
                  
                    if ($('#reservation-type').val() != 'bon_cadeau') {
                        if (window.matchMedia("(max-width: 884px)").matches) {
                            $(".js-list").css({
                                "padding-top": "90px"
                            });
                        }
                        masonryUpdate();
                        scrollTo($(".js-list"));
                    }

                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
            }
        });
    }
    function choiceOptions(){
        $.ajax({
            url: '/' + url_lang + '/ajax/reservation-choice',
            type: 'POST',
            data: {
                'type': $('#type').val(),
                'type_reservation': $('#reservation-type').val(),
                'choice': $checked_value,
                // 'promo_code': $('#promo-code').val(),
                'offer_firstname': $('#offer_firstname').val(),
                'offer_lastname': $('#offer_lastname').val(),
                'qty_adult': $('#quantity-A').val(),
                'qty_child': $('#quantity-E').val(),
                'qty_baby': $('#quantity-B').val()
            },
            dataType: 'json',
            success: function (data) {
                if (data.views) {
                    renderAjaxResponse(data);
                    stickyBlock();
                    if (data.display_option) {

                        masonryUpdate();
                        if (window.matchMedia("(max-width: 884px)").matches) {
                            $("#display-option").css({
                                "padding-top": "90px"
                            });
                        }
                        scrollTo($("#display-option"));
                    }
                    displayLoader(true);
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
            }
        });
    }
});

function renderAjaxResponse(data) {
    for (var htmlWrapper in data.views) {
        $('.' + htmlWrapper).replaceWith(data.views[htmlWrapper]);
    }
}

function stickyBlock() {

    if ($(window).scrollTop() >= ($('.reservation').offset().top + $('.reservation').height() - $('.reservation-ticket').height())) {
        $('.reservation-right-inner').removeClass('sticky');
        $('.reservation-right').addClass('bottom');
    } else if ($(window).scrollTop() >= $('.reservation').offset().top) {
        $('.reservation-right-inner').addClass('sticky');
        $('.reservation-right').removeClass('bottom');
    } else {
        $('.reservation-right-inner').removeClass('sticky');
        $('.reservation-right').removeClass('bottom');
    }
}

function number_format(number, decimals, dec_point, thousands_sep) {
    number = number.toFixed(decimals);

    var nstr = number.toString();
    nstr += '';
    x = nstr.split('.');
    x1 = x[0];
    x2 = x.length > 1 ? dec_point + x[1] : '';
    var rgx = /(\d+)(\d{3})/;

    while (rgx.test(x1))
        x1 = x1.replace(rgx, '$1' + thousands_sep + '$2');

    return x1 + x2;
}


